/**
 * Utilidades CUIT — espejo del helper PHP `App\Support\Cuit`.
 * Algoritmo módulo 11, prefijos válidos 20/23/24/27/30/33/34.
 */

export const PREFIJOS = ['20', '23', '24', '27', '30', '33', '34'];

export function normalize(cuit) {
  return String(cuit || '').replace(/\D/g, '');
}

export function isValid(cuit) {
  const c = normalize(cuit);
  if (c.length !== 11) return false;
  if (!PREFIJOS.includes(c.slice(0, 2))) return false;
  const mults = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 10; i++) sum += Number(c[i]) * mults[i];
  const resto = sum % 11;
  const dv = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;
  return Number(c[10]) === dv;
}

export function format(cuit) {
  const c = normalize(cuit);
  if (c.length !== 11) return cuit || '';
  return `${c.slice(0, 2)}-${c.slice(2, 10)}-${c.slice(10)}`;
}

/** Formato parcial mientras el usuario tipea (para máscara progresiva) */
export function formatPartial(cuit) {
  const c = normalize(cuit).slice(0, 11);
  if (c.length <= 2) return c;
  if (c.length <= 10) return `${c.slice(0, 2)}-${c.slice(2)}`;
  return `${c.slice(0, 2)}-${c.slice(2, 10)}-${c.slice(10)}`;
}

export function tipo(cuit) {
  const prefijo = normalize(cuit).slice(0, 2);
  if (['20', '23', '24', '27'].includes(prefijo)) return 'persona';
  if (['30', '33', '34'].includes(prefijo)) return 'empresa';
  return null;
}
